import type { BuilderCategory } from "api-types/builders/builderTypes";
import type { SvgIconProps } from "ui/icons/SVGIcon";
import SvgIcon from "ui/icons/SVGIcon";

interface IconBuilderCategoryProps extends SvgIconProps {
  category: BuilderCategory;
}

export default function IconBuilderCategory({ category, ...props }: IconBuilderCategoryProps) {
  switch (category) {
    case "CUSTOMER": {
      return (
        <SvgIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
          <path d="M0.5 0.5H8.5V11.5H0.5V0.5Z" stroke="currentColor" />
          <path d="M2 2.5H4" stroke="currentColor" />
          <path d="M2 5.5H7" stroke="currentColor" />
          <path d="M2 7.5H5" stroke="currentColor" />
          <path d="M11.4995 2L11.4995 12" stroke="currentColor" />
          <path
            d="M11 1.5L11.4124 0.55726C11.4277 0.522476 11.462 0.5 11.5 0.5C11.538 0.5 11.5723 0.522476 11.5876 0.55726L12 1.5L11 1.5Z"
            fill="currentColor"
          />
        </SvgIcon>
      );
    }
    case "DEMO": {
      return (
        <SvgIcon width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
          <rect x="1.20047" y="4.70717" width="25.3904" height="18.7928" rx="1.5" stroke="currentColor" />
          <circle cx="13.8957" cy="14.2948" r="4.99801" stroke="currentColor" />
          <path
            d="M16.0906 3.79482L17.4406 0.794818L16.9847 0.589635L17.4406 0.794818C17.5214 0.615392 17.6998 0.5 17.8966 0.5H21.1034C21.3002 0.5 21.4786 0.615392 21.5594 0.794818L22.9094 3.79482C23.0583 4.12569 22.8162 4.5 22.4534 4.5H16.5466C16.1838 4.5 15.9417 4.12569 16.0906 3.79482Z"
            stroke="currentColor"
          />
        </SvgIcon>
      );
    }
    case "PROSPECT": {
      return (
        <SvgIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
          <path
            d="M11.5 11.5H0.5V10.5C0.5 8.84315 1.84315 7.5 3.5 7.5H8.5C10.1569 7.5 11.5 8.84315 11.5 10.5V11.5Z"
            stroke="currentColor"
          />
          <circle cx="6" cy="3" r="2.5" stroke="currentColor" />
        </SvgIcon>
      );
    }
    case "TESTING": {
      return (
        <SvgIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
          <path
            d="M10.6384 11.5H1.36159C0.977679 11.5 0.736995 11.0853 0.927468 10.7519L4.5 4.5V0.5H7.5V4.5L11.0725 10.7519C11.263 11.0853 11.0223 11.5 10.6384 11.5Z"
            stroke="currentColor"
          />
          <path d="M2.5 8.00011C5 7.00009 7 9.00009 9.5 8.00011" stroke="currentColor" />
          <path d="M3 0.5H9" stroke="currentColor" />
        </SvgIcon>
      );
    }
    case "TRAINING": {
      return (
        <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 18.5H7.5C13.5751 18.5 18.5 13.5751 18.5 7.5V5.5" stroke="black" />
            <circle cx="18.5" cy="5.5" r="2" fill="white" stroke="black" />
            <circle cx="15.5" cy="15.5" r="2" fill="#1A1A1A" stroke="currentColor" />
            <circle cx="5.5" cy="18.5" r="2" fill="white" stroke="currentColor" />
          </svg>
        </SvgIcon>
      );
    }
    case "LEGACY": {
      return (
        <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.75"
            d="M8 4h1l3 3h7a2 2 0 0 1 2 2v8m-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 1.189-1.829M3 3l18 18"
          />
        </SvgIcon>
      );
    }
  }
}
